const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age, AgeOrder}  = require("../../Constants");
const { AddCostModifier, CostKinds } = require("../../../Effects/Effects");

const UrbanTypes = Object.values(TechnologyTypes.Urban);

class Construction extends Technology {
    constructor(age, techName, scienceCost, age1Discount, age2Discount,age3Discount, WonderStages){
        super(
            age,
            Construction.GetType(),
            techName,
            scienceCost,
            null,
            {
                playerStateAltering:
                    (playerState) => {
                        // Urban buildings of Age I and later cost less to build (and so to upgrade)
                        AddCostModifier(playerState, this, CostKinds.BuildCost, ({ tech }) => UrbanTypes.includes(tech.type)
                            ? -([0, age1Discount, age2Discount, age3Discount][AgeOrder.indexOf(tech.age)] ?? 0)
                            : 0);
                    }
            }
        )
        // How many wonder stages can be built for one civil action
        this.wonderStages = WonderStages;
        // What the card does, for its face, worded and laid out as printed: the discount on each age's urban buildings,
        // newest age first (one line each), then the wonder stages
        const discounts = [['III', age3Discount], ['II', age2Discount], ['I', age1Discount], ['A', 0]];
        this.text = ['Urban buildings have a reduced cost:',
            ...discounts.map(([age, amount]) => `${age}: -${amount} resource${amount === 1 ? '' : 's'}`),
            `You may build up to ${WonderStages} stages of a wonder for one civil action.`].join('\n');
    }
    static GetType = () => TechnologyTypes.Special.Construction
}

class Masonry extends Construction {
    constructor(){
        super(Masonry.GetAge(), Masonry.GetName(), 3, 1, 1, 1, 2)
    }

    static GetInstance = () => new Masonry();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Special.Masonry;
}

class Architecture extends Construction {
    constructor(){
        super(Architecture.GetAge(), Architecture.GetName(), 6, 1, 2, 2, 3)
    }

    static GetInstance = () => new Architecture();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Special.Architecture;
}

class Engineering extends Construction {
    constructor(){
        super(Engineering.GetAge(), Engineering.GetName(), 9, 1, 2, 3, 4)
    }

    static GetInstance = () => new Engineering();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Special.Engineering;
}

module.exports = {
    Masonry,
    Architecture,
    Engineering
}